import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { getComponentsSideData } from "assets/data/sideTabData";
import { useGlobalContext } from "context/GlobalContext";
import "assets/scss/pages/_DesignSystemComponents.scss";
import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import PreviewTableComponent from "components/DesignSystemPage/TableComponent/PreviewTableComponent";
import UsageTableComponent from "components/DesignSystemPage/TableComponent/UsageTableComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";
import { tableTokenTabData } from "assets/data/tokenTabData";


const Table = () => {
  const { id } = useParams();
  const { designSystemMeta, designSystem } = useGlobalContext();

  const tabData = ["Default"];
  const tabs = ["Preview", "Usage", "Tokens"];

  const componentName = "table";
  const componentKey = `Component/${componentName}`;
  const componentData = designSystem[componentKey];
  const tokenTableData = tableTokenTabData(componentData, componentName);

  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const bannerData = {
    heading: "Table",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };
  

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        // return <div>content1</div>;
        return (
          <PreviewTableComponent
            tabData={tabData}
            activeTab={activeTab}
            setSelectedTab={setSelectedTab}
            handleTabClick={handleTabClick}
          />
        );
      case 1:
        return (
          <div>
            <UsageTableComponent/>
          </div>
        );
      case 2:
        return <TokenTableComponent tokenTableData={tokenTableData} />;
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title='Components'
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default Table;
